import { render, staticRenderFns } from "./InspectionInput.vue?vue&type=template&id=2f0c7ba2&scoped=true&"
import script from "./InspectionInput.vue?vue&type=script&lang=ts&"
export * from "./InspectionInput.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionInput.vue?vue&type=style&index=0&id=2f0c7ba2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0c7ba2",
  null
  
)

export default component.exports